export const PWAUpdatePrompt = () => {
    // PWA更新提示已移除，让用户手动控制安装
    return null;
};